// removed by extract-text-webpack-plugin
module.exports = {"content":"_1RYbGF3V8"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/grid-ticket-modal/grid-ticket-modal.css
 ** module id = 2124
 ** module chunks = 0
 **/